/**
 * SHIPPING CARRIERS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getShippingCarriers,
    getShippingCarrier,
    printShippingCarrier,
    createShippingCarriers,
    updateShippingCarriers,
    deleteShippingCarriers,
} from "Core/companies/shipping_carriers/config/api.shipping_carriers";

const state = {
    page: {},
    form: {},
    shipping_carriers: [],
    shipping_carrier_options: [],
    selectedShippingCarrier: {
        company_id: null,
        company_id: "",
        shipping_carrier_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        shipping_carrier_details: [],
    },
    shipping_carriers_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        status: "1",
    },
    rules_shipping_carriers: {
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        parent_id: {
            name: "parent_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        stripe_id: {
            name: "stripe_id",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        zoho_customer_id: {
            name: "zoho_customer_id",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        organisation_type_id: {
            name: "organisation_type_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company: {
            name: "company",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        company_short: {
            name: "company_short",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        website: {
            name: "website",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        correspondence_method: {
            name: "correspondence_method",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "electronic",
        },
        currency_code: {
            name: "currency_code",
            rules: "trim|max_length[3]|required",
            max_len: "3",
            min_len: "",
            default_value: "USD",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "3",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        turn_around_days: {
            name: "turn_around_days",
            rules: "trim|max_length[3]|integer",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        has_nda: {
            name: "has_nda",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        has_contract: {
            name: "has_contract",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        ship_label_type: {
            name: "ship_label_type",
            rules: "trim|max_length[6]|required",
            max_len: "6",
            min_len: "",
            default_value: "normal",
        },
        notes: {
            name: "notes",
            rules: "trim",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        logo_id: {
            name: "logo_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        packing_list_fields: {
            name: "packing_list_fields",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        logo: {
            name: "logo",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        status: {
            name: "status",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        account_number: {
            name: "account_number",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    shipping_carriers: (state) => {
        return state.shipping_carriers;
    },
};

// actions
const actions = {
    async fetchShippingCarriers({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getShippingCarriers({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "shipping_carrier_options",
                        with: response.data.shipping_carriers,
                    });
                } else {
                    commit("mutate", {
                        property: "shipping_carriers",
                        with: response.data.shipping_carriers,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchShippingCarrier({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getShippingCarrier(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedShippingCarrier",
                    with: response.data.shipping_carrier,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printShippingCarrier({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printShippingCarrier(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveShippingCarrier({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["company_id"] === "undefined" || body["company_id"] == null || body["company_id"] == "") {
                delete body["company_id"];
                response = await createShippingCarriers({ body: body, headers: config.headers });
            } else {
                let company_id = body["company_id"];
                delete body["company_id"];
                response = await updateShippingCarriers({ body: body, headers: config.headers }, company_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteShippingCarrier({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteShippingCarriers(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
